import {
  RESET_STORE_DOCUMENT,
  REQUEST_SET_DOCUMENT_CONTENT,
} from 'containers/common/UploadDocument/constants';
import { fromJS } from 'immutable';

const initState = fromJS({
  document: null,
});

const UploadDocumentReducer = (
  state = initState,
  action: { payload: any; type: string },
) => {
  switch (action.type) {
    case REQUEST_SET_DOCUMENT_CONTENT:
      return state.set('document', fromJS(action.payload));
    case RESET_STORE_DOCUMENT: {
      return initState;
    }
    default:
      return state;
  }
};
export default UploadDocumentReducer;
